define('bizzabo/views/popup/TutorialView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'hbars!bizzabo/templates/tutorialPopUp'
], function(
    $,
    Backbone,
    _,
    Global,
    template
    ) {


    var TutorialView = Backbone.View.extend({
        events: {
            'click .tutorial-popup-tab': 'tabClicked',
            'click .tutorial-popup-next-button': 'nextClicked',
            'click .tutorial-popup-skip-button': 'remove'
        },

        tabClicked: function(e, openTab) {
            var NUMBER_OF_TABS = 4;
            var value = e ? $(e.target).parent().attr('value') : openTab + 1;
            if (!value) {
                return;
            } else if (value == NUMBER_OF_TABS) {
                this.remove();
            } else if (value == NUMBER_OF_TABS - 1) {
                this.$('.tutorial-popup-next-button').html("Done");
            } else {
                this.$('.tutorial-popup-next-button').html("Next");
            }
            _.each(this.$('.tutorial-popup-tab'), function(tab, index){
                if ($(tab).attr('value') == value) {
                    this.$(tab).toggleClass('tutorial-popup-tab-open',true);
                    this.$(tab).find('img').toggleClass('tutorial-popup-image-open',false);
                } else {
                    this.$(tab).find('img').toggleClass('tutorial-popup-image-open',true);
                    this.$(tab).toggleClass('tutorial-popup-tab-open',false);
                }
            }, this);
        },

        nextClicked: function() {
            var value = parseInt(this.$('.tutorial-popup-tab-open').attr('value'));
            this.tabClicked(undefined, value);
        },

        render: function() {
            $('body').append("<div class='tutorial-popup-overlay'></div>");
            this.$el.html(template());
            var thisView = this;
            setTimeout(function(){
                thisView.$('.tutorial-popup-container').toggleClass('tutorial-popup-opacity');
            }, 300);
            return this;
        },

        remove: function () {
            Global.appView.tutorialSeen = true;
            $('.tutorial-popup-overlay').remove();
            this.$el.remove();
            this.stopListening();
            return this;
        }
    });

    return TutorialView;

});
